import React, { useState, useEffect, useRef } from "react";
import styles from "./TypewriterText.module.css";

const TypewriterText = ({ text = "", speed = 75, className = "" }) => {
  const [displayedLength, setDisplayedLength] = useState(0);
  const targetLengthRef = useRef(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    const target = text?.length ?? 0;
    targetLengthRef.current = target;
    if (target === 0) {
      setDisplayedLength(0);
      return;
    }
    intervalRef.current = setInterval(() => {
      setDisplayedLength((prev) => {
        const targetNow = targetLengthRef.current;
        if (prev >= targetNow) {
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
          return prev;
        }
        return prev + 1;
      });
    }, speed);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [text, speed]);

  useEffect(() => {
    const len = text?.length ?? 0;
    targetLengthRef.current = len;
    if (displayedLength > len) {
      setDisplayedLength(len);
    }
  }, [text, displayedLength]);

  const displayText = (text || "").slice(0, displayedLength);
  const isTyping = displayedLength < (text?.length ?? 0);

  return (
    <span className={className}>
      {displayText.split("\n").map((line, i, arr) => (
        <React.Fragment key={i}>
          {line}
          {i < arr.length - 1 && <br />}
        </React.Fragment>
      ))}
      {isTyping && <span className={styles.cursor} />}
    </span>
  );
};

export default TypewriterText;
